var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('v-progress-circular',{staticClass:"preloader__element",attrs:{"color":"red","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }